<!-- start page title -->
<section class="half-section parallax lg-h-200px xs-h-auto p-0" data-parallax-background-ratio="0.5"
  style="background-image:url('assets/img/portfolio-bg.jpg');">
  <div class="container">
    <div class="row align-items-stretch justify-content-center extra-small-screen">
      <div
        class="col-12 col-xl-6 col-lg-7 col-md-8 page-title-extra-small text-center d-flex justify-content-center flex-column">
        <h1 class="alt-font text-gradient-sky-blue-pink margin-15px-bottom d-inline-block">Order Confirmation</h1>
        <!-- <h2 class="text-extra-dark-gray alt-font font-weight-500 letter-spacing-minus-1px line-height-50 sm-line-height-45 xs-line-height-30 no-margin-bottom">Every new print and color of the season</h2> -->
      </div>
    </div>
  </div>
</section>
<!-- end page title -->
<!-- start section -->
<section class="shopping-left-side-bar pt-0 page-height">
  <div class="container">
    <div class="row">
        <div class="col-md-6">
            <h2>Thank you for placing your order with us.</h2>
        </div>
    </div>
  </div>
</section>
<!-- end section -->
